import { FC } from "react";
import { Visibility } from "@mui/icons-material";

import { useMetamaskValue, useWriteContractWithSimulation } from "@dzambalaorg/react-hooks-eth";
import { formatEther } from "@framework/exchange";
import { ListAction, ListActionVariant } from "@framework/styled";
import { type AddressType, type IBalance, TokenType } from "@framework/types";
import VestingReleasableABI from "@framework/abis/json/Vesting/releasable.json";

export interface IVestingReleasableButtonProps {
  balance: IBalance;
  className?: string;
  disabled?: boolean;
  variant?: ListActionVariant;
}

export const VestingReleasableButton: FC<IVestingReleasableButtonProps> = props => {
  const { balance, className, disabled, variant } = props;

  const { writeContractAsync } = useWriteContractWithSimulation();

  const { execute: metaReleasable } = useMetamaskValue(
    async (balance: IBalance) => {
      if (balance.token?.template?.contract?.contractType === TokenType.ERC20) {
        return writeContractAsync({
          address: balance.account as AddressType,
          abi: VestingReleasableABI,
          functionName: "releasable",
          args: [balance.token.template.contract.address],
        });
      } else if (balance.token?.template?.contract?.contractType === TokenType.NATIVE) {
        return writeContractAsync({
          address: balance.account as AddressType,
          abi: VestingReleasableABI,
          functionName: "releasable",
          args: [],
        });
      } else {
        throw new Error("unsupported token type");
      }
    },
    { success: false },
  );

  const handleClick = async () => {
    const amount = await metaReleasable(balance) as unknown as number;

    if (amount) {
      alert(
        `Releasable: ${formatEther(
          amount.toString(),
          balance.token?.template?.contract?.decimals,
          balance.token?.template?.contract?.symbol,
        )}`,
      );
    }
  };

  return (
    <ListAction
      onClick={handleClick}
      icon={Visibility}
      message="form.tips.releasable"
      className={className}
      dataTestId="VestingReleasableButton"
      disabled={disabled}
      variant={variant}
    />
  );
};
